import React, { Component } from 'react'
import { observable, action, makeObservable } from 'mobx'
import { observer, inject } from 'mobx-react'

import { listenEmbedMessage } from 'utils/embedWidget.utils'
import { getLinkByParams } from 'utils/embeddableItems.utils'

import { POST_MESSAGE_ACTIONS } from '../../common/variables'

@inject('productsStore')
@observer
class EmbedPaymentPage extends Component {
  @observable iframeInited = false

  constructor(props) {
    super(props)
    makeObservable(this)
  }

  componentDidMount() {
    this.initIframeResizing()
    listenEmbedMessage(this.handleMessage)
  }

  initIframeResizing = () => {
    const iframe = document.getElementById('embedPaymentPage')
    iframe.contentWindow.postMessage({ action: 'loadCompleted' }, '*')
    if (!this.iframeInited) {
      return setTimeout(this.initIframeResizing, 50)
    }
  }

  @action handleMessage = (data) => {
    const iframe = document.getElementById('embedPaymentPage')
    if (data.action === 'loadCompleted') {
      this.iframeInited = true
    } else if (data.action === 'resize') {
      iframe.style.height = `${data.height}px`
    } else if (data.action === POST_MESSAGE_ACTIONS.redirection) {
      window.parent.postMessage(
        {
          action: POST_MESSAGE_ACTIONS.redirection,
          url: data.url,
          iframeSrc: window.location.href,
        },
        '*'
      )
    }
  }

  render() {
    const {
      productLink,
      productsStore: { item: product },
    } = this.props
    const url = getLinkByParams(productLink, product, {}, true)
    return (
      <div id='embedPaymentPageContainer' style={{ backgroundColor: 'transparent' }}>
        <iframe id='embedPaymentPage' src={url} frameBorder={0} style={{ width: '100%' }} />
      </div>
    )
  }
}

export default EmbedPaymentPage
